const PENDING_OPERATIONS_KEY = 'remu_bucket_pending_operations_v1';
const APP_AUTH_TOKEN_KEY = 'auth_token';
const CONNECT_GUEST_TOKEN_KEY = 'connect_guest_token';

const getApiBaseUrl = () => process.env.REACT_APP_API_BASE_URL || '/api/v1';

const readQueue = () => {
  try {
    const raw = localStorage.getItem(PENDING_OPERATIONS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const writeQueue = (queue) => {
  localStorage.setItem(PENDING_OPERATIONS_KEY, JSON.stringify(queue));
};

// Buffers a finished device session locally; the ESP32 AP has no internet, so
// sending has to wait until the browser reconnects to a real network.
export const queueDeviceOperation = (operation) => {
  const queue = readQueue();
  queue.push({ ...operation, queuedAt: new Date().toISOString() });
  writeQueue(queue);
};

export const flushPendingOperations = async () => {
  const queue = readQueue();
  if (queue.length === 0) {
    return;
  }

  const token = localStorage.getItem(APP_AUTH_TOKEN_KEY) || localStorage.getItem(CONNECT_GUEST_TOKEN_KEY);
  if (!token) {
    return;
  }

  const remaining = [];

  for (const operation of queue) {
    try {
      const response = await fetch(`${getApiBaseUrl()}/bucket-operations/device`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(operation)
      });

      if (!response.ok) {
        remaining.push(operation);
      }
    } catch (error) {
      remaining.push(operation);
    }
  }

  writeQueue(remaining);
};

export const startOperationSync = () => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  void flushPendingOperations();

  const handleOnline = () => {
    void flushPendingOperations();
  };

  window.addEventListener('online', handleOnline);
  const timer = setInterval(() => {
    void flushPendingOperations();
  }, 15000);

  return () => {
    window.removeEventListener('online', handleOnline);
    clearInterval(timer);
  };
};
